function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00335 3.99986C3.95012 3.99986 4.71763 3.23235 4.71763 2.28557C4.71763 1.3388 3.95012 0.571289 3.00335 0.571289C2.05657 0.571289 1.28906 1.3388 1.28906 2.28557C1.28906 3.23235 2.05657 3.99986 3.00335 3.99986Z",
  stroke: "#6B6C7E",
  strokeWidth: 1.71429,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00335 9.71373C3.95012 9.71373 4.71763 8.94622 4.71763 7.99944C4.71763 7.05267 3.95012 6.28516 3.00335 6.28516C2.05657 6.28516 1.28906 7.05267 1.28906 7.99944C1.28906 8.94622 2.05657 9.71373 3.00335 9.71373Z",
  stroke: "#6B6C7E",
  strokeWidth: 1.71429,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00335 15.4286C3.95012 15.4286 4.71763 14.6611 4.71763 13.7143C4.71763 12.7675 3.95012 12 3.00335 12C2.05657 12 1.28906 12.7675 1.28906 13.7143C1.28906 14.6611 2.05657 15.4286 3.00335 15.4286Z",
  stroke: "#6B6C7E",
  strokeWidth: 1.71429,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMenuIcon = function SvgMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 16,
    viewBox: "0 0 6 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-icon.4c5af61f.svg";
export { ForwardRef as ReactComponent };